if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.sessionStorageCodeKey = 'cart-discount-last-used-code';
      this.sessionStorageParentKey = 'cart-discount-last-used-parent';
    }

    connectedCallback() {
      if (window.SHOPIFY_STOREFRONT_API_URL == null || window.SHOPIFY_STOREFRONT_ACCESS_TOKEN == null) {
        return;
      }

      this.cartId = null;
      this.discounts = [];
      this.getCurrentCart();
    }

    init() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.input = this.form.querySelector('input');
      this.submitButton = this.form.querySelector('button');
      if (!this.input || !this.submitButton) return;
      this.removeAllButton = this.querySelector('.cart-discount__remove-all');
      this.cart = document.querySelector('cart-drawer-items') || this.querySelector('cart-items');
      this.errorElement = document.querySelectorAll(`.cart-discount__error`);
      this.discountWrapper = this.querySelector('.discounts');
      this.discountTemplate = this.querySelector('template.discount-template');
      this.bindRemoveDiscount = this.removeDiscount.bind(this);

      this.style.setProperty('--button-width', `${Math.ceil(this.submitButton.getBoundingClientRect().width)}px`);

      this.setRemoveButtons();

      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      if (this.removeAllButton) this.removeAllButton.addEventListener('click', this.removeAllDiscounts.bind(this));
      this.classList.remove('hidden');
    }

    getCurrentCart() {
      fetch(`${Shopify.routes.root}cart.js`)
        .then((response) => {
          return response.json();
        })
        .then((state) => {
          this.cartToken = state.token;
          this.cartId = this.cartToken.split('?')[0];

          this.getCurrentDiscounts();
        })
        .catch((err) => {
          console.error('[CART-DISCOUNT]', err);
        });
    }

    getCurrentDiscounts() {
      const query = `
        query {
          cart(id: "gid://shopify/Cart/${this.cartToken}") {
            id
            discountCodes {
              code
              applicable
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .then((state) => {
          const discountCodes = state.data?.cart?.discountCodes || [];
          if (discountCodes && discountCodes.length > 0) {
            discountCodes.map((discount) => {
              if (discount.applicable) {
                this.discounts.push(this.filterCodeValue(discount.code));
              }
            });
          }

          this.init();
          this.checkDiscountApplication();
        })
        .catch((err) => {
          console.error(err);
        });
    }

    refreshDiscountState() {
      const query = `
        query {
          cart(id: "gid://shopify/Cart/${this.cartToken}") {
            discountCodes {
              code
              applicable
            }
          }
        }
      `;
      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .then((state) => {
          const discountCodes = state.data?.cart?.discountCodes || [];
          this.discounts = discountCodes
            .filter((discount) => discount.applicable)
            .map((discount) => this.filterCodeValue(discount.code));

          const lastAppliedDiscount = sessionStorage.getItem(this.sessionStorageCodeKey);
          if (lastAppliedDiscount) {
            const errorEl = this.querySelector('.cart-discount__error');
            if (!this.discounts.includes(this.filterCodeValue(lastAppliedDiscount)) && errorEl) {
              errorEl.innerHTML = window.cartStrings.discountInvalidCode.replace('[code]', lastAppliedDiscount);
            }
            requestAnimationFrame(() => {
              sessionStorage.removeItem(this.sessionStorageCodeKey);
              sessionStorage.removeItem(this.sessionStorageParentKey);
            });
          }

          if (this.discountTemplate && this.discountWrapper) {
            this.unsetRemoveButtons();
            this.discounts.forEach((discount) => {
              if (!this.shownDiscountCodes.includes(this.filterCodeValue(discount))) {
                const clone = this.discountTemplate.content.cloneNode(true);
                const item = clone.querySelector('.discount-template-wrapper');
                item.innerHTML = item.innerHTML.replace(/\[code\]/g, discount);
                this.discountWrapper.appendChild(item.querySelector('.discounts__discount'));
              }
            });
            this.setRemoveButtons();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

    updateDiscounts(discounts, keepOpen = false) {
      const query = `
        mutation {
          cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${this.cartToken}", discountCodes: ${JSON.stringify(
        discounts
      )}) {
            cart {
              id
              discountCodes {
                code
                applicable
              }
            }
            userErrors {
              code
              field
              message
            }
          }
        }
      `;

      fetch(window.SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      })
        .then((response) => response.json())
        .catch((err) => {
          console.error(err);
          if (this.errorElement) {
            this.errorElement.textContent = window.cartStrings.discountError;
          }
        })
        .finally(() => {
          const sheet = this.closest('discount-bottom-sheet');
          if (sheet && !keepOpen) {
            sheet._restoreImmediate();
          } else if (keepOpen && sheet && sheet._portalParent) {
            this.refreshDiscountState();
          }
          this.cart.onCartUpdate();
          this.setLoadingForm(false);
        });
    }

    onFormSubmit(event) {
      event.preventDefault();
      this.setLoadingForm(true);
      const newDiscount = this.filterCodeValue(this.form.querySelector('input').value);

      sessionStorage.setItem(this.sessionStorageCodeKey, this.form.querySelector('input').value);
      sessionStorage.setItem(this.sessionStorageParentKey, this.dataset.parentSelector);
      const discountCodes = [...this.discounts, newDiscount];

      const sheet = this.closest('discount-bottom-sheet');
      const keepOpen = sheet ? sheet.dataset.keepOpen === 'true' : false;
      this.updateDiscounts(discountCodes, keepOpen);
    }

    removeDiscount(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      const code = this.filterCodeValue(event.currentTarget.dataset.code);
      const discountCodes = this.discounts.filter((discount) => discount !== code);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);
      this.newDiscount = null;

      this.updateDiscounts(discountCodes);
    }

    removeAllDiscounts(event) {
      event.preventDefault();
      this.setLoadingForm(true);

      sessionStorage.removeItem(this.sessionStorageCodeKey);
      sessionStorage.removeItem(this.sessionStorageParentKey);

      this.updateDiscounts([]);
    }

    checkDiscountApplication() {
      const lastAppliedDiscount = sessionStorage.getItem(this.sessionStorageCodeKey);
      const parentSelector = sessionStorage.getItem(this.sessionStorageParentKey);
      const errorElement = document.querySelector(`${parentSelector ? parentSelector : ''} .cart-discount__error`);

      if (lastAppliedDiscount) {
        if (!this.discounts.includes(this.filterCodeValue(lastAppliedDiscount)) && errorElement) {
          errorElement.innerHTML = window.cartStrings.discountInvalidCode.replace('[code]', lastAppliedDiscount);
        }
        requestAnimationFrame(() => {
          sessionStorage.removeItem(this.sessionStorageCodeKey);
          sessionStorage.removeItem(this.sessionStorageParentKey);
        });
      }

      if (this.discountTemplate && this.discountWrapper) {
        this.unsetRemoveButtons();

        this.discounts.forEach((discount) => {
          if (!this.shownDiscountCodes.includes(this.filterCodeValue(discount))) {
            const clone = this.discountTemplate.content.cloneNode(true);
            const item = clone.querySelector('.discount-template-wrapper');
            item.innerHTML = item.innerHTML.replace(/\[code\]/g, discount);
            this.discountWrapper.appendChild(item.querySelector('.discounts__discount'));
          }
        });

        this.setRemoveButtons();
      }
    }

    setRemoveButtons() {
      this.removeDiscountButtons = this.querySelectorAll('.discount--remove');
      this.shownDiscountCodes = Array.from(this.removeDiscountButtons).map((button) =>
        this.filterCodeValue(button.dataset.code)
      );

      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    unsetRemoveButtons() {
      this.removeDiscountButtons.forEach((button) => {
        button.addEventListener('click', this.bindRemoveDiscount);
      });
    }

    setLoadingForm(disable) {
      if (disable) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.removeAllButton) this.removeAllButton.setAttribute('disabled', true);
        if (this.removeAllButton) this.removeAllButton.setAttribute('aria-disabled', true);

        this.input.setAttribute('disabled', true);
        this.input.setAttribute('aria-disabled', true);

        this.removeDiscountButtons.forEach((button) => {
          button.setAttribute('disabled', true);
          button.setAttribute('aria-disabled', true);
        });
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

        if (this.removeAllButton) this.removeAllButton.removeAttribute('disabled');
        if (this.removeAllButton) this.removeAllButton.removeAttribute('aria-disabled');

        this.input.removeAttribute('disabled');
        this.input.removeAttribute('aria-disabled');

        this.removeDiscountButtons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        });
      }
    }

    filterCodeValue(code) {
      return code.trim().toLowerCase();
    }
  }

  customElements.define('cart-discount', CartDiscount);
}

if (!customElements.get('discount-bottom-sheet')) {
  class DiscountBottomSheet extends HTMLElement {
    constructor() {
      super();
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.handleHandleBarClick = this.handleHandleBarClick.bind(this);
      this.dragStartY = null;
      this.currentDragY = 0;
      this._triggers = [];
      this.cartDrawerObserver = null;
      this._portalParent = null;
      this._portalSibling = null;
      this._isPortaling = false;
    }

    connectedCallback() {
      if (this._isPortaling) return;
      this.overlay = this.querySelector('.discount-sheet__overlay');
      this.panel = this.querySelector('.discount-sheet__panel');
      this.handleBar = this.querySelector('.discount-sheet__handle-bar');

      this.overlay?.addEventListener('click', this.handleOverlayClick);

      if (this.handleBar) {
        this.handleBar.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.handleBar.addEventListener('touchmove', this.onTouchMove, { passive: false });
        this.handleBar.addEventListener('touchend', this.onTouchEnd);
        this.handleBar.addEventListener('click', this.handleHandleBarClick);
      }

      const context = this.closest('#CartDrawer, #main-cart-footer') || document;
      this._triggers = Array.from(context.querySelectorAll('[data-discount-trigger]'));
      this._triggers.forEach((btn) => {
        btn.addEventListener('click', this.handleTriggerClick);
      });

      this.cartDrawer = this.closest('cart-drawer');
      if (this.cartDrawer) {
        this.cartDrawerObserver = new MutationObserver(() => {
          if (!this.cartDrawer.classList.contains('active')) {
            this.close();
          }
        });
        this.cartDrawerObserver.observe(this.cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    disconnectedCallback() {
      if (this._isPortaling) return;
      this.overlay?.removeEventListener('click', this.handleOverlayClick);
      if (this.handleBar) {
        this.handleBar.removeEventListener('touchstart', this.onTouchStart);
        this.handleBar.removeEventListener('touchmove', this.onTouchMove);
        this.handleBar.removeEventListener('touchend', this.onTouchEnd);
        this.handleBar.removeEventListener('click', this.handleHandleBarClick);
      }
      if (this.cartDrawerObserver) {
        this.cartDrawerObserver.disconnect();
        this.cartDrawerObserver = null;
      }
      this._triggers.forEach((btn) => btn.removeEventListener('click', this.handleTriggerClick));
      this._triggers = [];
      document.body.style.overflow = '';
    }

    _restoreImmediate() {
      if (!this._portalParent) return;
      this.classList.remove('is-open');
      if (this.overlay) {
        this.overlay.style.opacity = '';
        this.overlay.style.visibility = '';
      }
      document.body.style.overflow = '';

      const portalParent = this._portalParent;
      const portalSibling = this._portalSibling;
      this._portalParent = null;
      this._portalSibling = null;

      this._isPortaling = true;
      if (portalSibling && portalSibling.parentNode === portalParent) {
        portalParent.insertBefore(this, portalSibling);
      } else {
        portalParent.appendChild(this);
      }
      this._isPortaling = false;
      this.classList.remove('discount-sheet--main-cart');
    }

    open() {
      if (!this.closest('cart-drawer')) {
        this._portalParent = this.parentNode;
        this._portalSibling = this.nextSibling;
        this._isPortaling = true;
        document.body.appendChild(this);
        this._isPortaling = false;
        this.classList.add('discount-sheet--main-cart');
      }
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        if (this.overlay) {
          this.overlay.style.opacity = '1';
          this.overlay.style.visibility = 'visible';
        }
      });
      document.body.style.overflow = 'hidden';
    }

    openImmediate() {
      if (!this.closest('cart-drawer')) {
        this._portalParent = this.parentNode;
        this._portalSibling = this.nextSibling;
        this._isPortaling = true;
        document.body.appendChild(this);
        this._isPortaling = false;
        this.classList.add('discount-sheet--main-cart');
      }
      this.classList.add('discount-sheet--no-transition');
      this.classList.add('is-open');
      if (this.overlay) {
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
      }
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        this.classList.remove('discount-sheet--no-transition');
      });
    }

    close() {
      this.classList.remove('is-open');
      if (this.overlay) {
        this.overlay.style.opacity = '';
        this.overlay.style.visibility = '';
      }
      if (this.panel) this.panel.style.transform = '';
      document.body.style.overflow = '';

      if (this._portalParent) {
        const portalParent = this._portalParent;
        const portalSibling = this._portalSibling;
        this._portalParent = null;
        this._portalSibling = null;

        let restored = false;
        const restore = () => {
          if (restored) return;
          restored = true;
          this._isPortaling = true;
          if (portalSibling && portalSibling.parentNode === portalParent) {
            portalParent.insertBefore(this, portalSibling);
          } else {
            portalParent.appendChild(this);
          }
          this._isPortaling = false;
          this.classList.remove('discount-sheet--main-cart');
        };

        const panel = this.querySelector('.discount-sheet__panel');
        if (panel) {
          panel.addEventListener('transitionend', restore, { once: true });
        }
        setTimeout(restore, 350);
      }
    }

    handleOverlayClick() {
      this.close();
    }

    handleTriggerClick() {
      this.open();
    }

    handleHandleBarClick() {
      this.close();
    }

    onTouchStart(event) {
      this.dragStartY = event.touches[0].clientY;
      this.currentDragY = 0;
      if (this.panel) this.panel.style.transition = 'none';
    }

    onTouchMove(event) {
      if (this.dragStartY === null) return;
      const delta = event.touches[0].clientY - this.dragStartY;
      if (delta > 0) {
        event.preventDefault();
        this.currentDragY = delta;
        if (this.panel) this.panel.style.transform = `translateY(${delta}px)`;
      }
    }

    onTouchEnd() {
      if (this.panel) this.panel.style.transition = '';
      if (this.currentDragY > 80) {
        this.close();
      } else {
        if (this.panel) this.panel.style.transform = '';
      }
      this.dragStartY = null;
      this.currentDragY = 0;
    }
  }

  customElements.define('discount-bottom-sheet', DiscountBottomSheet);
}